import { render } from "./ExchangeInventoryDetails.vue?vue&type=template&id=27cd1be0"
import script from "./ExchangeInventoryDetails.vue?vue&type=script&lang=js"
export * from "./ExchangeInventoryDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__